import * as React from "react";
import { SVGProps } from "react";
const SvgEventList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    {...props}
  >
    <path d="M647.74-144Q618-144 597-165.18q-21-21.17-21-50.91v-144.17Q576-390 597.18-411q21.17-21 50.91-21h144.17Q822-432 843-410.82q21 21.17 21 50.91v144.17Q864-186 842.82-165q-21.17 21-50.91 21H647.74Zm.26-72h144v-144H648v144ZM96-252v-72h384v72H96Zm551.74-276Q618-528 597-549.18q-21-21.17-21-50.91v-144.17Q576-774 597.18-795q21.17-21 50.91-21h144.17Q822-816 843-794.82q21 21.17 21 50.91v144.17Q864-570 842.82-549q-21.17 21-50.91 21H647.74Zm.26-72h144v-144H648v144ZM96-636v-72h384v72H96Zm624 348Zm0-384Z" />
  </svg>
);
export default SvgEventList;
